<div>
    <!-- Price preview here -->
    <h3>{{ priceFormat }}</h3>
</div>
